export default {
  title: 'Hoe verwerkingskosten werken',
  how_it_works:
    'Stripe brengt zijn kosten in rekening bij je platform voor elke online betaling die je restaurants ontvangen. De verwerkingskosten die je instelt, betaalt het restaurant voor die betaling. Als dit hoger is dan de kosten van Stripe, houd je het verschil als marge. Als het lager is, of als je niets instelt, betaal je het verschil zelf.',
  stripe_rates_link: 'Bekijk de standaardtarieven van Stripe',
  example: {
    intro:
      'Voorbeeld: een bestelling van {{total}} betaald met kaart. Stripe rekent je platform {{stripe_fee}} ({{stripe_rate}}) aan.',
    above: 'Jouw tarief {{rate}}: het restaurant betaalt {{fee}}, jij houdt {{difference}}.',
    below: 'Jouw tarief {{rate}}: het restaurant betaalt {{fee}}, jij betaalt het verschil van {{difference}}.',
    none: 'Geen tarief (0% marge): het restaurant betaalt niets, jij betaalt de volledige {{stripe_fee}}.',
    disclaimer:
      'De kosten van Stripe zijn hier het standaard kaarttarief in de EER, ter illustratie. Je werkelijke kosten hangen af van de kaart, het land en je Stripe-prijzen.',
  },
};
